export const LOGIN = 'infomail/auth/LOGIN';
export const LOGOUT = 'infomail/auth/LOGOUT';
export const SET_USER = 'infomail/auth/SET_USER';
